import { Injectable } from '@angular/core';
import {Actions, ofType, createEffect} from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import {Action, Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import {
    catchError,
    exhaustMap,
    map,
    switchMap,
    withLatestFrom,
    distinctUntilChanged,
    mergeMap,
    filter
} from 'rxjs/operators';
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import {
    getPreviews,
} from '@signature-it/ngx-entity/store/selectors';
import { EntityService} from '@signature-it/ngx-entity/services';
import * as fromSelectors from "@signature-it/ngx-entity/store/selectors";
import {FavoritesDTO} from '@signature-it/ngx-entity/models';
import { FavoritesService } from "@signature-it/ngx-entity/services";
import {LanguageService} from "@signature-it/ngx-generic/services";

declare let _: any;
@Injectable()
export class EntityEffects {
    constructor(
        private actions$: Actions,
        private entityService: EntityService,
        private store$ : Store,
        protected favoritesSvc: FavoritesService,
        protected langSvc: LanguageService,
    ) {}
    getPreview$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EntityActions.getPreviews),
            concatLatestFrom(action => this.store$.select(getPreviews)),
            exhaustMap(([action, previews]) => {
                if (previews) return of(EntityActions.getPreviewsSuccess(previews));
                return this.entityService.getEntityPreviews().pipe(
                    map(previews => EntityActions.getPreviewsSuccess(previews)),
                    catchError(error => of(EntityActions.getPreviewsError({error}))
                    )
                )
                }
            ))
    );

    getFavorites$ = createEffect(() =>
        this.actions$.pipe(ofType(EntityActions.GET_FAVORITES),
            withLatestFrom(this.store$.select(fromSelectors.selectEntityStore)),
            exhaustMap(([state, entityState]) => {
                if (entityState.favoritesList && !entityState.processingAddToFavorites) return of(EntityActions.getFavoritesSuccess(entityState.favoritesList));
                return this.favoritesSvc.getEntityFavoriteList().pipe(
                    map((data: FavoritesDTO[]) => EntityActions.getFavoritesSuccess(data)),
                    catchError(error => of(EntityActions.getFavoritesFailure()))
                );
            })));

    addFavorite$= createEffect(() =>
        this.actions$.pipe(ofType(EntityActions.ADD_FAVORITE),
            map((action) => action['payload']),
            switchMap((payload) => {
                return this.favoritesSvc.addEntityFavorites(payload).pipe(
                    map((data) => {
                        this.store$.dispatch(EntityActions.getFavorites());
                        return EntityActions.addFavoriteSuccess(payload);
                    }),
                    catchError(error => of(EntityActions.addFavoriteFailure()))
                );
            })));

    removeFavorite$= createEffect(() =>
        this.actions$.pipe(ofType(EntityActions.REMOVE_FAVORITE),
            map((action) => action['payload']),
            switchMap((payload) => {
                return this.favoritesSvc.removeEntityFavorites(payload).pipe(
                    map((data) => EntityActions.removeFavoriteSuccess(payload)),
                    catchError(error => of(EntityActions.removeFavoriteFailure()))
                );
            })));

}
